function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
/*
 *  Shopify Section Class
 *    Provides common API, as well as easy initalization for Shopify Sections
 *
 *  Version:
 *    1.0.0 - 2019/01/08
 */

import $ from 'jquery';
var Sections = {};
export var register = function register(selector, initializer) {
  return Sections[selector] = initializer;
};
export var deregister = function deregister(selector) {
  return delete Sections[selector];
};
export var ShopifySection = /*#__PURE__*/_createClass(
//container - jQuery container element
function ShopifySection(container) {
  _classCallCheck(this, ShopifySection);
  this.container = container;

  //Only sections that are really sections can be.. sections
  this.isSection = this.container.attr('data-section') && this.container.attr('data-section-id');

  //Get attributes
  if (this.isSection) {
    this.class = this.container.attr('class');
    this.id = this.container.attr('data-section-id');
  }
});

//Initialize
$(document).ready(function () {
  var keys = Object.keys(Sections);
  keys.forEach(function (selector) {
    var init = Sections[selector];
    $(selector).each(function (i, e) {
      new init($(e));
    });
  });
});